import { Component } from '@angular/core'
// Styles loaded via src/styles/styles.less -> components/error-page.less

@Component({
    selector: 'ca-error-404',
    templateUrl: './error-404.component.html',
    standalone: false
})
export class Error404Component {

    goBack(): void {
        window.history.go(-2)
    }

}